/* unplugin-vue-components disabled */import { render } from "./DifficultySettings.vue?vue&type=template&id=1a33f37c&scoped=true"
import script from "./DifficultySettings.vue?vue&type=script&lang=js"
export * from "./DifficultySettings.vue?vue&type=script&lang=js"

import "./DifficultySettings.vue?vue&type=style&index=0&id=1a33f37c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a33f37c"]])

export default __exports__